export class WorldMapCamera {
	constructor(map, stage, heading) {
		this.map = map;
		this.stage = stage;
		this.heading = heading;
		this.card = stage.parentElement.querySelector(".global-presence__card");
		this.current = null;
		this.target = null;
		this.origin = null;
		this.started = null;
		this.lastRender = null;
		this.moving = false;
		this.quality = "full";
	}

	focus(location, overview, expansion, immediate = false) {
		const { width, height } = this.stage.getBoundingClientRect();
		const ratio = width / Math.max(height, 1);
		const baseWidth = Math.max(1000, 420 * ratio);
		const zoom = overview ? 1 : width < 768 ? (this.quality === "full" ? 2.5 : 1.8)
			: (this.quality === "full" ? 1.7 : 1.5);
		const viewWidth = !overview && location?.width
			? Math.max(baseWidth / zoom, location.width, location.height * ratio) : baseWidth / zoom;
		const viewHeight = viewWidth / ratio;
		const rightHeading = location?.headingSide === "right";
		const focusX = expansion < 0.98 ? 0.5 : (rightHeading ? 0.36 : 0.62);
		// Keep the complete 1000 × 420 map vertically centred with a little
		// breathing room, regardless of the viewport aspect ratio.
		const target = overview ? [500 - viewWidth / 2, 215 - viewHeight / 2, viewWidth, viewHeight]
			: [location.x - viewWidth * focusX, location.y - viewHeight * 0.5, viewWidth, viewHeight];
		const margin = width * 0.05;
		const headingY = height * (location?.headingY || 0.12);
		const clearTop = this.card.offsetTop - this.heading.offsetHeight - 20;
		target.push(rightHeading ? width - this.heading.offsetWidth - margin : margin,
			rightHeading ? headingY : Math.max(16, Math.min(headingY, clearTop)));
		if (this.target?.every((value, index) => Math.abs(value - target[index]) < 0.01)) {
			if (immediate && this.moving) {
				this.current = [...this.target];
				this.moving = false;
				this.render();
			}
			return;
		}
		this.target = target;
		if (!this.current || immediate) {
			this.current = [...target];
			this.moving = false;
			this.render();
			return;
		}
		this.origin = [...this.current];
		this.started = null;
		this.lastRender = null;
		this.moving = true;
	}

	tick(time) {
		if (!this.moving) return;
		const frameInterval = this.quality === "full" ? 14 : 30;
		if (this.lastRender !== null && time - this.lastRender < frameInterval) return;
		this.lastRender = time;
		this.started ??= time;
		const duration = this.quality === "full" ? 700 : 600;
		const progress = Math.min(1, (time - this.started) / duration);
		const eased = 1 - (1 - progress) ** 3;
		this.current = this.origin.map((value, index) => value + (this.target[index] - value) * eased);
		this.render();
		this.moving = progress < 1;
	}

	render() {
		// Redraw only during a short camera transition; keep vector geometry sharp.
		this.map.setAttribute("viewBox", this.current.slice(0, 4).map(value => value.toFixed(3)).join(" "));
		this.heading.style.transform = `translate3d(${this.current[4].toFixed(2)}px, ${this.current[5].toFixed(2)}px, 0)`;
	}
}
